<template>
  <div class="user-avator-dropdown">
    <Dropdown @on-click="handleClick">
      <span style='color:#fff;'>{{userName}}</span>
      <Icon :size="16" type="ios-arrow-down" style='color:#fff;margin:0 10px;'></Icon>
      <!--<Avatar :src="userAvator"/>-->

      <DropdownMenu slot="list">
        <DropdownItem name="logout">退出登录</DropdownItem>
      </DropdownMenu>
    </Dropdown>
    <Avatar style="background-color: #87d068" icon="ios-person" />
  </div>
</template>

<script>
import './user.less'
import { mapActions } from 'vuex'
export default {
  name: 'User',
  props: {
    userAvator: {
      type: String,
      default: ''
    },
    userName: {
      type: String,
      default: ''
    }
  },
  methods: {
    ...mapActions([
      'handleLogOut'
    ]),
    handleClick (name) {
      switch (name) {
        case 'logout':
          this.handleLogOut().then(() => {
            this.$router.push({
              name: 'login'
            })
          })
          break
      }
    }
  }
}
</script>
